<template>
  <!-- <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    fixed
    :dark="true"
    app
    v-model="drawer"
    width="260"
    >
    <v-toolbar color="primary darken-1" dark> -->
  <v-navigation-drawer
  style="background:#fa4242"
  id="appDrawer"
  :mini-variant.sync="mini"
  fixed
  app
  v-model="drawer"
  width="150"
  >
    <vue-perfect-scrollbar class="drawer-menu--scroll background-grey" :settings="scrollSettings">
      <v-list dense expand class="drawer-menu--list" style="padding-top:50px">
        <template v-for="(item, i) in menus">
            <!--group with subitems-->
            <v-list-group v-if="item.items" :key="item.name" :group="item.group" :prepend-icon="item.icon" no-action="no-action">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title><div class="menuTitle">{{ item.title }}</div></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}aa</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
                <!--child item-->
                <v-list-tile v-else :key="i" :to="genChildTarget(item, subItem)" :href="subItem.href" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title><v-icon small style="margin-right:10px;">{{ subItem.icon }}</v-icon><span>{{ subItem.title }}</span></v-list-tile-title>
                  </v-list-tile-content>
                  <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                  <v-list-tile-action v-if="subItem.action">
                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list-group>
            <div :key="i" v-else-if="item.header" :class="i < 2 ? 'menuHeader' : 'menuHeader-second'" >
              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t(item.header) }}</span>
            </div>
            <!-- <v-subheader v-else-if="item.header" :key="i" dark>{{ $t(item.header) }}</v-subheader> -->
            <v-divider v-else-if="item.divider" :key="i"></v-divider>
            <!--top-level link-->
            <v-list-tile style="height:50px; margin-bottom:35px;" v-show="!item.hidden && (item.isView === undefined || item.isView === true)" 
              v-else 
              :to="!item.href ? (item.disabled) ? null : { name: item.name } : null" 
              :href="item.href" 
              ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
              <v-list-tile-action v-if="item.icon">
                <v-icon :color="item.disabled ? 'grey' : ''" >{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title><div class="menuTitle">{{ !item.params ? $t(item.title) : $t(item.title, item.params) }}</div></v-list-tile-title>
              </v-list-tile-content>
              <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
              <v-list-tile-action v-if="item.subAction">
                <v-icon class="success--text">{{ item.subAction }}</v-icon>
              </v-list-tile-action>
              <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
            </v-list-tile>
        </template>
      </v-list>        
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import pkg from '../../package';
import menu from '@/api/menu';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Util from '@/util';

export default {
  name: 'app-drawer',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    title: pkg.title,
    mini: false,
    drawer: false,
    menus: null,
    licMenus: null,
    scrollSettings: {
      maxScrollbarLength: 160
    },
    items: [
      { title: 'Home', icon: 'dashboard' },
      { title: 'About', icon: 'question_answer' }
    ],
  }),
  computed: {
    computeGroupActive () {
      return true;
    },
    computeLogo () {
      return '/static/images/company_ecs.gif';
    },

    sideToolbarColor () {
      return this.$vuetify.options.extra.sideNav;
    }    
  },
  created () {
    window.getApp.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer);
    });
  },
  async mounted () {
    if (!Util.hasSession(this, true)) return;
    if (this.$store.state.user !== null && this.$store.state.user.authorize === 'u') {
      this.menus = menu.filter(elem => elem.isAdmin === false);
    } else {
      this.menus = menu;
    }

    this.licMenus = [
      {
        title: 'LG Chem',
        group: 'apps',
        icon: 'mdi-information',
        name: 'LgLicense',  // router/paths.js 에 라이선스 페이지 추가한다음 그 name 값 넣으면 됨.
        refresh: true,
        isAdmin: true
      },
    ];

    let isDashboardDetail = false;
    let isUserViewRecordFiles = false;
    let helpDeskNumber = '';
    let ciscoWebexHub = `https://admin.webex.com`;
    if (this.$store.state.user !== null) {
      ciscoWebexHub += `?email=${this.$store.state.user.email}`;
    }
    
    let settings = (await this.$http.get('/api/v1/systems')).data;
    try {
      if (settings !== '') {
        isDashboardDetail = settings.systems.isDashboardDetail;
        isUserViewRecordFiles = settings.systems.isUserViewRecordFiles;
        helpDeskNumber = settings.systems.helpDeskNumber;
        ciscoWebexHub = `${settings.systems.ciscoWebexHub}`;
        if (this.$store.state.user !== null) {
          ciscoWebexHub += `?email=${this.$store.state.user.email}`;
        }
      }
    } catch (e) {
      console.log(e);
    }

    menu.forEach((element) => {
      if (element.items) {
        let items = element.items;
        items.sort((a, b) => {
          return a.sort < b.sort ? -1 : a.sort > b.sort ? 1 : 0;
        });
      } else {
        if (element.name === 'Records') {
          element.isView = true;
        }
        if (element.name === 'Dashboard') {
          element.isView = isDashboardDetail;
        }
        if (element.name === 'DashboardSimple') {
          element.isView = true;
        }
        if (element.name === 'HelpDesk') {
          if (helpDeskNumber !== '') {
            element.isView = true;
            element['params'] = { helpDeskNumber: helpDeskNumber };
          }
        }
        if (element.name === 'CiscoWebexHub') {
          if (ciscoWebexHub !== '') {
            element.isView = true;
            element.href = ciscoWebexHub;
          }
        }
      }
    }, menu);

    /*
    Vue 오류(?)로 주석
     if (settings.systems.mainPage !== 'my-meeting') {
       const index = menu.findIndex(item => item.title === `menu.${settings.systems.mainPage}`);
       [menu[1], menu[2]] = [menu[index], menu[1]];
    } 
    */
  },
  methods: {
    genChildTarget (item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return { name: `${item.group}/${(subItem.name)}` };
    },
  }
};
</script>


<style lang="stylus">
#appDrawer
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto
  .drawer-menu--list
    margin-top:-4px

.menuTitle {
  height: 50px;
  padding-bottom: 36px;
  font-size: 18px;
  color: #fff;
  font-size: 18px;
  text-align: center;
}

.disableMenuTitle {
  color: #9E9E9E;
}

.non-a-tag {
  text-decoration: none !important;
  color: inherit;
}

.menuHeader {
  background: linear-gradient(to top, #7D5F3C, #95816A);
  // background: #f37321;  
  // background: linear-gradient(to top, #035E7E, #01ACDA);
  height: 50px;
  font-size: 17px;
  font-weight: 450;
  width:259px;
  text-align: left;
  display: table-cell;
  vertical-align: middle;
}

.menuHeader-second {
  background: linear-gradient(to top, #7D5F3C, #95816A);
  // background: #f89b6c;
  height: 50px;
  font-size: 17px;
  font-weight: 450;
  width:259px;
  text-align: left;
  display: table-cell;
  vertical-align: middle;
}

.menuHeader span{
  color: #FFFFFF;
}

.menuHeader-second span{
  color: #FFFFFF;
}

.background-grey {
  background: #fa4242;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDrawer.vue